import type { StyleSpecification } from "maplibre-gl";

import { MAP_THEME } from "./map-theme";

// Basemap selection for the Command Center map. With a MapTiler PUBLISHABLE key we use a real
// MapTiler basemap; with no key we fall back to a privacy-safe BLANK local grid — a solid
// background with ZERO third-party calls (checkpoint pins still plot on top). Mirrors the pilot's
// "blank grid fallback" posture.

const MAPTILER_STYLE_IDS: Record<string, string> = {
  streets: "streets-v2",
  satellite: "satellite",
  hybrid: "hybrid",
};

export function buildMapStyleUrl(mapTilerKey: string, mapStyle: string): string {
  const styleId = MAPTILER_STYLE_IDS[mapStyle] ?? MAPTILER_STYLE_IDS.hybrid;
  return `https://api.maptiler.com/maps/${styleId}/style.json?key=${encodeURIComponent(mapTilerKey)}`;
}

/** Privacy-safe blank style — solid background, no sources, no third-party requests. */
export const BLANK_STYLE: StyleSpecification = {
  version: 8,
  sources: {},
  layers: [
    {
      id: "background",
      type: "background",
      paint: { "background-color": MAP_THEME.blankBackground },
    },
  ],
};

/** A MapTiler style URL when a publishable key is present; otherwise the blank local grid. */
export function buildMapStyle(
  mapTilerKey: string | undefined,
  mapStyle: string,
): string | StyleSpecification {
  if (typeof mapTilerKey === "string" && mapTilerKey.length > 0) {
    return buildMapStyleUrl(mapTilerKey, mapStyle);
  }
  return BLANK_STYLE;
}
